import { render, staticRenderFns } from "./certificateManage.vue?vue&type=template&id=83c59216&"
import script from "./certificateManage.vue?vue&type=script&lang=js&"
export * from "./certificateManage.vue?vue&type=script&lang=js&"
import style0 from "./certificateManage.vue?vue&type=style&index=0&id=83c59216&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports